import { render, staticRenderFns } from "./FinanceScreenSettlements.vue?vue&type=template&id=8e9441d4&scoped=true"
import script from "./FinanceScreenSettlements.vue?vue&type=script&lang=js"
export * from "./FinanceScreenSettlements.vue?vue&type=script&lang=js"
import style0 from "./FinanceScreenSettlements.vue?vue&type=style&index=0&id=8e9441d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9441d4",
  null
  
)

export default component.exports